// Static menu data for Giridhar Veg Restaurant.
// Source: owner-provided menu CSV. Descriptions added where helpful.
export const RESTAURANT = {
  name: "Giridhar Veg Restaurant",
  tagline: "Pure Vegetarian Excellence Since 1991",
  established: 1991,
  founder: "Bhivlal Bishnoi",
  city: "Pune, Maharashtra, India",
  address: "Shop 7, Swojas CHS, Parihar Chowk, Aundh 411007",
  phone: "+91 85518 96868",
  phoneRaw: "+918551896868",
  email: "support@giridharveg.com",
  gstin: "27ALGPB6672E1Z7",
  fssai: "11521034000100",
  hours: [
    { day: "Open all days", time: "9:00 AM – 11:00 PM" },
  ],
  mapsQuery: "Giridhar Veg Restaurant Parihar Chowk Aundh Pune",
  mapsLat: 18.5608164,
  mapsLng: 73.8095055,
  mapsPlaceId: "0x3bc2bf3900000001:0x77c83fefc0621d8a",
};

export const MENU = [
  {
    id: "snacks",
    label: "Snacks",
    description: "Quick bites and breakfast classics, made fresh each morning.",
    items: [
      { name: "Medu Wada Sambar", price: 70, desc: "Crispy urad-dal donuts with hot sambar and coconut chutney." },
      { name: "Batata Wada Sambar", price: 60, desc: "Spiced potato fritters dunked in tangy sambar." },
      { name: "Mix Wada Sambar", price: 70, desc: "A pairing of medu and batata wada served with sambar." },
      { name: "Idli / Wada Sambar (Single)", price: 40, desc: "One idli or one wada with sambar and chutney." },
      { name: "Idli Sambar", price: 60, desc: "Soft steamed rice cakes with sambar and coconut chutney." },
      { name: "Misal Pav", price: 70, desc: "Pune-style spiced sprouts curry topped with farsan, served with pav." },
      { name: "Wada Pav", price: 20, desc: "Mumbai's classic — spiced potato dumpling in a soft pav." },
      { name: "Dahi Misal", price: 80, desc: "Our signature misal topped with cooling yogurt." },
      { name: "Dahi Wada", price: 70, desc: "Lentil dumplings soaked in spiced yogurt and chutneys." },
      { name: "Poha", price: 40, desc: "Flattened rice tempered with mustard, onion and curry leaves.", note: "Available 9 AM – 11 AM only" },
      { name: "Dahi Wada (Single)", price: 40, desc: "One dahi wada — a light yogurt-based bite." },
      { name: "Sabudana Khichadi", price: 60, desc: "Sago pearls with peanuts, cumin and green chilli." },
      { name: "Upma", price: 40, desc: "Semolina tempered with mustard, ginger and curry leaves.", note: "Available 9 AM – 11 AM only" },
      { name: "Shira (Pure Ghee)", price: 40, desc: "Sweet semolina pudding cooked in pure ghee.", note: "Available 9 AM – 11 AM only" },
    ],
  },
  {
    id: "thali",
    label: "Thali",
    description: "Complete meals — sabji, dal, rice, bread and dahi on one plate.",
    items: [
      { name: "Rice Plate", price: 120, desc: "Dal, rice, sabji, chapati, papad and dahi.", note: "Served 11:30 AM – 11 PM" },
      { name: "Mini Punjabi Roti", price: 130, desc: "Two rotis with a Punjabi sabji, dal fry, jeera rice and dahi.", note: "Served 11:30 AM – 11 PM" },
      { name: "Chapati Bhaji", price: 75, desc: "3 chapati, sabji and dahi — a wholesome quick meal." },
      { name: "Mini Punjabi", price: 120, desc: "A compact Punjabi platter with sabji, dal fry and jeera rice.", note: "Served 11:30 AM – 11 PM" },
      { name: "Puri Bhaji", price: 80, desc: "5 puris with sabji and dahi." },
      { name: "Pithal Bhakri", price: 90, desc: "Maharashtrian pithla with 2 bhakris and dahi." },
      { name: "Matki Bhakri", price: 90, desc: "Sprouted matki usal with 2 bhakris and dahi." },
    ],
  },
  {
    id: "tandoori",
    label: "Tandoori & Breads",
    description: "Hand-stretched, tandoor-baked breads and stuffed parathas.",
    items: [
      { name: "Roti (Plain)", price: 25, desc: "Whole-wheat tandoor roti, served warm." },
      { name: "Roti (Butter)", price: 30, desc: "Tandoor roti brushed with white butter." },
      { name: "Nan (Plain)", price: 40, desc: "Soft leavened flatbread baked in the tandoor." },
      { name: "Nan (Butter)", price: 50, desc: "Naan topped with a generous swipe of butter." },
      { name: "Garlic Nan (Plain)", price: 60, desc: "Naan studded with fresh garlic and coriander." },
      { name: "Garlic Nan (Butter)", price: 70, desc: "Garlic naan, finished with butter." },
      { name: "Aloo Paratha", price: 90, desc: "Whole-wheat paratha stuffed with spiced potato masala." },
      { name: "Gobi Paratha", price: 90, desc: "Hand-rolled paratha stuffed with grated, spiced cauliflower." },
      { name: "Aloo Gobi Paratha", price: 100, desc: "Stuffed with potato and cauliflower masala." },
      { name: "Aloo Onion Paratha", price: 100, desc: "Stuffed with potato and caramelised onion masala." },
      { name: "Stuff Paratha", price: 100, desc: "Chef's daily stuffed paratha — ask the server." },
      { name: "Palak Paratha", price: 100, desc: "Soft paratha stuffed with spinach and mild spices." },
      { name: "Paneer Paratha", price: 110, desc: "Generous house-made paneer filling, lightly spiced." },
      { name: "Cheese Paratha", price: 110, desc: "Melted cheese inside a hand-rolled paratha." },
      { name: "Stuff Cheese Paratha", price: 130, desc: "Cheese with the chef's daily stuffing of the day." },
      { name: "Aloo Cheese Paratha", price: 130, desc: "Potato masala and melted cheese, double layered." },
    ],
  },
  {
    id: "rice",
    label: "Rice & Biryani",
    description: "Aromatic rice, biryanis and slow-cooked khichdi.",
    items: [
      { name: "Plain Rice (Half)", price: 40, desc: "Steamed basmati rice — half portion." },
      { name: "Plain Rice (Full)", price: 60, desc: "Steamed basmati rice — full portion." },
      { name: "Dal Rice (Half)", price: 60, desc: "Tempered dal over rice — half portion." },
      { name: "Dal Rice (Full)", price: 90, desc: "Tempered dal over rice — full portion." },
      { name: "Jeera Rice (Half)", price: 80, desc: "Basmati tempered with cumin and ghee — half portion." },
      { name: "Jeera Rice (Full)", price: 130, desc: "Basmati tempered with cumin and ghee — full portion." },
      { name: "Curd Rice", price: 150, desc: "South-style cooling rice tempered with mustard and curry leaves." },
      { name: "Dal Khichadi", price: 140, desc: "One-pot rice and dal comfort, finished with ghee." },
      { name: "Palak Khichadi", price: 150, desc: "Khichadi cooked with spinach and mild spices." },
      { name: "Veg Pulav", price: 150, desc: "Basmati with seasonal vegetables and whole spices." },
      { name: "Spl. Veg Pulav", price: 170, desc: "Our special pulav with extra vegetables and ghee tempering." },
      { name: "Kaju Pulav", price: 200, desc: "Mildly spiced pulav loaded with roasted cashews." },
      { name: "Cheese Pulav", price: 200, desc: "Fragrant pulav finished with melted cheese." },
      { name: "Veg Biryani", price: 180, desc: "Layered basmati with vegetables, mint and biryani masala." },
      { name: "Paneer Biryani", price: 190, desc: "Layered biryani with marinated paneer cubes." },
      { name: "Mashroom Biryani", price: 190, desc: "Slow-steamed biryani with sautéed mushrooms." },
    ],
  },
  {
    id: "paneer",
    label: "Paneer Sabji",
    description: "House-made paneer in our classic and signature gravies.",
    items: [
      { name: "Paneer Butter", price: 170, desc: "Velvet tomato-cashew gravy with cubes of fresh paneer." },
      { name: "Paneer Mutter", price: 170, desc: "Paneer and green peas in a mild onion-tomato gravy." },
      { name: "Paneer Masala", price: 170, desc: "Classic paneer in a spiced onion-tomato masala." },
      { name: "Paneer Palak", price: 170, desc: "Stone-ground spinach with paneer, tempered with garlic." },
      { name: "Paneer Burji", price: 180, desc: "Scrambled paneer with onion, tomato and green chilli." },
      { name: "Paneer Mashroom", price: 200, desc: "Paneer and mushrooms in a creamy onion gravy." },
      { name: "Paneer Kadai", price: 230, desc: "Paneer with bell peppers in roasted coriander-pepper masala." },
      { name: "Paneer Tikka Masala", price: 230, desc: "Tandoor-charred paneer in a rich, smoky tomato gravy." },
    ],
  },
  {
    id: "veg-sabji",
    label: "Veg Sabji",
    description: "Seasonal vegetables in our heritage masalas.",
    items: [
      { name: "Mix Veg", price: 170, desc: "Mixed vegetables in a mild, family-style gravy." },
      { name: "Veg Kolhapuri", price: 170, desc: "Maharashtrian classic with fiery coconut-sesame masala." },
      { name: "Shev Bhaji", price: 170, desc: "Khandeshi gravy topped with crisp besan sev." },
      { name: "Mashroom Masala", price: 170, desc: "Mushrooms in a spiced onion-tomato masala." },
      { name: "Veg Bhuna", price: 200, desc: "Slow-roasted vegetables in a deep, dry-style gravy." },
      { name: "Veg Maratha", price: 200, desc: "Our chef's special Marathi-style mixed vegetable curry." },
      { name: "Veg Kadai", price: 230, desc: "Mixed veg with bell peppers in kadai masala." },
      { name: "Kaju Masala", price: 240, desc: "Whole cashews in a luxurious onion-tomato gravy." },
      { name: "Plain Palak", price: 140, desc: "Simple stone-ground spinach with garlic tempering." },
      { name: "Aloo Mutter", price: 150, desc: "Potato and green peas in a light tomato gravy." },
      { name: "Aloo Gobi", price: 150, desc: "Potato and cauliflower stir-fried with onion and spices." },
      { name: "Aloo Palak", price: 150, desc: "Potato cubes in stone-ground spinach gravy." },
      { name: "Aloo Jeera", price: 140, desc: "Cumin-tempered potatoes — dry-style, lightly spiced." },
      { name: "Chana Masala", price: 150, desc: "Slow-cooked chickpeas with anardana and roasted spices." },
      { name: "Bhendi Masala", price: 150, desc: "Okra in a tangy onion-tomato masala." },
      { name: "Bhendi Fry", price: 140, desc: "Crisp dry-fried okra with onion and garlic." },
      { name: "Baingan Masala", price: 150, desc: "Brined brinjal cooked in a spiced gravy." },
      { name: "Green Peas Masala", price: 150, desc: "Sweet green peas in a mild, family-style gravy." },
    ],
  },
  {
    id: "dals",
    label: "Dals",
    description: "Slow-simmered lentils — the soul of every Indian meal.",
    items: [
      { name: "Dal Fry", price: 120, desc: "Yellow dal tempered with cumin, garlic and ghee." },
      { name: "Dal Tadka", price: 130, desc: "Tuvar dal finished with a fiery garlic-chilli tempering." },
      { name: "Butter Dal Fry", price: 130, desc: "Our dal fry, enriched with a knob of white butter." },
      { name: "Dal Palak", price: 130, desc: "Yellow lentils simmered with fresh spinach." },
    ],
  },
  {
    id: "hot-drinks",
    label: "Hot Drinks",
    description: "Brewed strong, served warm.",
    items: [
      { name: "Tea", price: 20, desc: "Our everyday Pune-style cutting chai." },
      { name: "Spl. Tea", price: 35, desc: "Strong masala chai with ginger and cardamom." },
      { name: "Black Tea", price: 25, desc: "Brewed black tea, no milk." },
      { name: "Black Tea (Lemon)", price: 30, desc: "Black tea finished with fresh lemon." },
      { name: "Nes. Coffee", price: 35, desc: "Hot instant coffee, frothed milk." },
      { name: "Milk (Half)", price: 30, desc: "Half glass of hot milk." },
      { name: "Milk (Full)", price: 50, desc: "Full glass of hot milk." },
      { name: "Bournvita", price: 60, desc: "Hot milk with malt chocolate." },
    ],
  },
  {
    id: "cold-drinks",
    label: "Cold Drinks",
    description: "Cooling sips for warm Pune days.",
    items: [
      { name: "Lassi", price: 30, desc: "Thick, hand-churned yogurt drink — sweet or salted." },
      { name: "Butter Milk", price: 25, desc: "Spiced chaas, tempered with curry leaves and ginger." },
      { name: "Solkadhi", price: 25, desc: "Konkan coconut-kokum drink, lightly spiced." },
      { name: "Cold Drinks (300 ml)", price: 30, desc: "Chilled bottled soft drink." },
      { name: "Mineral Water", price: 20, desc: "Sealed bottled water." },
    ],
  },
  {
    id: "extras",
    label: "Extras",
    description: "Add-ons and accompaniments to round off your meal.",
    items: [
      { name: "Chapati", price: 10, desc: "Plain whole-wheat chapati." },
      { name: "Butter Chapati", price: 15, desc: "Chapati brushed with butter." },
      { name: "Bhakri", price: 25, desc: "Rustic jowar bhakri, hand-patted and griddled." },
      { name: "Puri Plate 5 nos.", price: 30, desc: "Five hot, puffed puris." },
      { name: "Pav Jodi", price: 10, desc: "A pair of soft pav buns." },
      { name: "Papad", price: 10, desc: "Roasted or fried — your call." },
      { name: "Dahi Wati", price: 10, desc: "A small bowl of plain set yogurt." },
      { name: "Chatni / Sambar / Sample", price: 10, desc: "Extra serving of chutney, sambar or sample." },
      { name: "Mini Sabji", price: 50, desc: "A small bowl of the day's sabji." },
      { name: "Gravy Sabji", price: 50, desc: "A small portion of any gravy sabji." },
      { name: "Dry Sabji", price: 50, desc: "A small portion of any dry sabji." },
      { name: "Aloo Sabji", price: 50, desc: "A small portion of our daily aloo sabji." },
      { name: "Pithale Wati", price: 50, desc: "A small bowl of Maharashtrian pithla." },
      { name: "Matki Wati", price: 50, desc: "A small bowl of sprouted matki usal." },
      { name: "Mini Dal", price: 30, desc: "A small bowl of plain dal." },
      { name: "Mini Rice", price: 30, desc: "A small portion of steamed rice." },
      { name: "Plain Dal", price: 20, desc: "Simple yellow dal, lightly seasoned." },
    ],
  }
];
